/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type BottomBar_viewer = {
    readonly footerSupportLinks: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SiteNav_viewer">;
    readonly " $refType": "BottomBar_viewer";
};
export type BottomBar_viewer$data = BottomBar_viewer;
export type BottomBar_viewer$key = {
    readonly " $data"?: BottomBar_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"BottomBar_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BottomBar_viewer",
    "selections": [
        {
            "alias": "footerSupportLinks",
            "args": [
                {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "footerSupportLinks"
                }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"footerSupportLinks\")"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SiteNav_viewer"
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = 'e87ce02171b5ced372f52d48513d5500';
export default node;
